// extracted by css-extract-rspack-plugin
export default {"root":"O8vvzh"};